var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildLoopCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.49367,
    height: 149.49367,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 149.49367 149.49367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2063.58653,
    y1: 2451.45069,
    x2: -2041.19518,
    y2: 2451.45069,
    gradientTransform: "translate(-2430.45617 -1975.77768) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 149.49367,
    height: 149.49367,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pg0gl4d9eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.03703,9.99272c-9.15746.05203-18.09458,2.81379-25.68488,7.93718l32.55224,32.12713c3.67194,3.59252,3.73734,9.53956.07475,13.2115-3.62791,3.6682-9.54232,3.70166-13.2115.07475L16.21539,31.21615c-5.00542,7.66308-7.64405,16.63019-7.5868,25.78299.17285,25.7316,21.24212,46.55326,47.00642,46.41312,4.06899-.03528,8.11603-.60063,12.03891-1.68181l12.54813,12.38929-.00935.00935,2.59278,2.5414.72411.71477,26.72199,26.15672c3.684,3.60959,9.59662,3.54926,13.20621-.13474.00176-.00181.00354-.00361.0053-.00542l19.60703-20.02748c3.60906-3.68715,3.54631-9.60174-.14015-13.2115l-27.16581-26.59586-4.39605-4.36335-.0327-.0327-10.85231-10.6888c1.06025-3.93696,1.58354-7.99915,1.55567-12.07629-.14015-25.7643-21.24211-46.55326-47.00642-46.41311h.00467ZM92.69541,56.47123c.04723,5.00898-.92222,9.97548-2.84973,14.59899l16.52373,16.34153-.01402.01402,2.71424,2.65819.60264.59798,26.72199,26.15672-19.60703,20.02748-27.33398-26.75937-19.32206-19.10716c-4.5945,2.01234-9.55509,3.05409-14.57096,3.05995-20.61144.15417-37.47152-16.55175-37.59299-37.13049,0-3.33558.42512-6.57772,1.21931-9.66103l23.00334,22.7137c3.57383,3.49908,8.28288,5.42849,13.27223,5.40981,4.98935-.01869,9.65635-1.98546,13.15544-5.5593,3.53179-3.54113,5.42849-8.28288,5.4098-13.27223s-1.98546-9.65635-5.55929-13.15544l-23.00333-22.71371c3.13427-.88897,6.37513-1.34634,9.633-1.35946,20.61144-.15417,37.50422,16.51438,37.59298,37.13049l.00467.00934Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68102,87.80885v-22.39135h32.62699v22.39135H4.68102Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.66826,68.19714l-12.15571,1.88736H4.89125l-.38308-42.04509h32.89328l9.34335,28.03006-11.07654,12.12767Z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h149.49367v149.49367H0V0Z",
    fill: "#0550DC"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23.38642,
    cy: 46.59998,
    r: 14.01503,
    fill: "#0550DC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildLoopCard);
export default __webpack_public_path__ + "static/media/BuildLoopCard.f03d310183cf3a3e98a63ef7b53c3b46.svg";
export { ForwardRef as ReactComponent };